module.exports = __webpack_public_path__ + "img/checkmark.997da106.svg";